<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex align-items-center">
          <h2 class="mb-0">Invoice Preview</h2>
          <div
            class="prospects-panel d-flex justify-content-between ms-2 me-auto">
            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radiobutton
                inputId="Open"
                value="Open"
                class="me-2"
                name="radio"
                [(ngModel)]="selectedRadioButton"
                [ariaChecked]="selectedRadioButton === 'Open' ? true : false"
                (onClick)="getOrderOnChange($event)" />

              <span class="link">Open</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radiobutton
                inputId="Approved"
                value="Approved"
                class="me-2"
                name="radio"
                [(ngModel)]="selectedRadioButton"
                [ariaChecked]="selectedRadioButton === 'Approve' ? true : false"
                (onClick)="getOrderOnChange($event)" />

              <span class="link">Approved</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radiobutton
                inputId="Wrong"
                value="Wrong"
                class="me-2"
                name="radio"
                [(ngModel)]="selectedRadioButton"
                [ariaChecked]="selectedRadioButton === 'Wrong' ? true : false"
                (onClick)="getOrderOnChange($event)" />

              <span class="link">Wrong</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radiobutton
                inputId="Invoiced"
                value="Invoiced"
                class="me-2"
                name="radio"
                [(ngModel)]="selectedRadioButton"
                [ariaChecked]="
                  selectedRadioButton === 'Invoiced' ? true : false
                "
                (onClick)="getOrderOnChange($event)" />

              <span class="link">Invoiced</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radiobutton
                inputId="Canceled"
                value="Canceled"
                class="me-2"
                name="radio"
                [(ngModel)]="selectedRadioButton"
                [ariaChecked]="
                  selectedRadioButton === 'Canceled' ? true : false
                "
                (onClick)="getOrderOnChange($event)" />

              <span class="link">Canceled</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <p-radiobutton
                inputId="All"
                value="All"
                class="me-2"
                name="radio"
                [(ngModel)]="selectedRadioButton"
                [ariaChecked]="selectedRadioButton === 'All' ? true : false"
                (onClick)="getOrderOnChange($event)" />

              <span class="link">All</span>
            </label>
          </div>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <div class="orders-panel col-auto d-flex justify-content-between">
            <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <p-button
                label="Export Excel"
                variant="outlined"
                icon="pi pi-cloud-upload"
                severity="secondary"
                (click)="exportExcel()"
                class="fullwdth secondary-btn" />
            </div>
          </div>
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          stripedRows
          responsiveLayout="scroll"
          [value]="invoicePreviewList"
          styleClass="p-datatable-customers ordersListing search-more"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="true"
          [rows]="defaultTake"
          [lazy]="true"
          (onLazyLoad)="getAllInvoicePreviewListingData($event)"
          [totalRecords]="totalRecords"
          sortMode="multiple"
          [globalFilterFields]="[]"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th
                style="width: 3rem"
                class="number"
                pSortableColumn="invoicePreviewNumber">
                IP #
                <p-sortIcon field="invoicePreviewNumber"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="ipCreatedDateD365">
                Date<p-sortIcon field="ipCreatedDateD365"></p-sortIcon>
              </th>
              <th class="name" pSortableColumn="customerName">
                Customer<p-sortIcon field="customerName"></p-sortIcon>
              </th>
              <th class="jname" pSortableColumn="customerNumber">
                Cust # <p-sortIcon field="customerNumber"></p-sortIcon>
              </th>
              <th class="buyer" pSortableColumn="orderNumber">
                Order # <p-sortIcon field="orderNumber"></p-sortIcon>
              </th>
              <th class="inhanddate">Cust PO</th>
              <th class="date-time">IP Status</th>
              <th class="subtotal">Billing Comment</th>
              <th class="commission">PB</th>
              <th class="gp">Net Comm</th>
              <th class="gp">Net GP %</th>
              <th class="currency">Total Sell</th>
              <th class="cust-po">Freight total</th>
              <th class="bconsultant">Total Tax</th>
              <th class="bconsultant">Invoice Total</th>
              <th class="bconsultant">Credits/Payments</th>
              <th class="bconsultant">Total Due</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="invoicePreviewNumber"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <!-- <p-columnFilter
              type="text"
              field="date"
              (input)="onFilterInput($event)"
              [showMenu]="false"
            ></p-columnFilter> -->
                  <jni-date-filter
                    (emitApplyFilter)="onFilterInput($event)"
                    (emitCancelFilter)="onFilterInput($event, 'clear')"
                    [columnName]="dateFieldName"
                    [filterMode]="filterMode"
                    [dataList]="invoicePreviewList">
                  </jni-date-filter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="customerName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="customerNumber"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="orderNumber"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th></th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="previewStatus"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-invoicePreviewList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="invoicePreviewList"
              [pSelectableRowIndex]="rowIndex">
              <td
                class="number"
                (click)="
                  openInvoice(
                    invoicePreviewList?.invoicePreviewNumber,
                    invoicePreviewList?.orderNumber
                  )
                ">
                <a class="link">
                  {{ invoicePreviewList?.invoicePreviewNumber }}</a
                >
              </td>
              <td class="status">
                <span
                  *ngIf="
                    invoicePreviewList?.ipCreatedDateD365 | hidedynamicsdate
                  ">
                  {{
                    invoicePreviewList?.ipCreatedDateD365 | date: "MM-dd-yyyy"
                  }}
                </span>
              </td>
              <td
                class="name"
                (click)="
                  redirectToClientSummary(invoicePreviewList?.customerNumber)
                ">
                <a class="link">{{ invoicePreviewList?.customerName }}</a>
              </td>
              <td
                class="jname"
                class="name"
                (click)="
                  redirectToClientSummary(invoicePreviewList?.customerNumber)
                ">
                <a class="link">{{ invoicePreviewList?.customerNumber }}</a>
              </td>
              <td
                class="buyer"
                (click)="redirectToSummary(invoicePreviewList?.orderNumber)">
                <a class="link">{{ invoicePreviewList?.orderNumber }}</a>
              </td>
              <td class="inhandate">
                {{ invoicePreviewList?.customerPONumber }}
              </td>
              <td class="date-time">
                <a
                  class="link"
                  (click)="onStatusClick(invoicePreviewList?.orderNumber)"
                  *ngIf="
                    invoicePreviewList?.previewStatus?.toLowerCase() ===
                    'invoiced'
                  ">
                  {{ invoicePreviewList.previewStatus }}
                </a>
                <span
                  *ngIf="
                    !(
                      invoicePreviewList?.previewStatus?.toLowerCase() ===
                      'invoiced'
                    )
                  "
                  >{{ invoicePreviewList.previewStatus }}</span
                >
              </td>
              <!-- <td
          [ngClass]="{
            'highlight-comment':
              invoicePreviewList?.commentDate > invoicePreviewList?.lastViewDate
          }"
          style="max-width: 200px"
          class="subtotal"
          (mouseenter)="
            onHoverBillingComments(
              invoicePreviewList?.invoicePreviewNumber,
              invoicePreviewList?.billingComment
            )
          "
        >
          <div class="has-dropdown d-flex align-items-center">
            <a
              [title]="invoicePreviewList?.billingComment"
              class="link"
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ invoicePreviewList?.billingComment }}
            </a>
            <jni-invoice-preview-billing-comment
              *ngIf="orderNotesGridListing.length > 0"
              [orderNotesGridListing]="orderNotesGridListing"
              [orderNumber]="invoicePreviewList?.orderNumber"
              [orderBillingHeading]="'Billing Comments'"
              class="ratings-box overall ms-2"
              (scrollHiddenStatus)="addScollHiddenClass()"
              (orderNotesDisplayModalEvent)="
                orderNotesDisplayModalFunction($event)
              "
            >
            </jni-invoice-preview-billing-comment>
          </div>
        </td> -->
              <td
                [title]="invoicePreviewList?.billingComment"
                class="commission"
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 200px;
                ">
                {{ invoicePreviewList?.billingComment }}
              </td>
              <td class="commission">
                {{ invoicePreviewList?.isPreBill }}
              </td>
              <td class="gp text-right">
                {{
                  invoicePreviewList?.netCommission
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="gp text-right">
                {{ invoicePreviewList?.netGPPercentage | number: "1.2-2" }}
              </td>
              <td class="currency text-right">
                {{
                  invoicePreviewList?.totalSell
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>

              <td class="cust-po text-right">
                {{
                  invoicePreviewList?.freightTotal
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="bconsultant text-right">
                {{
                  invoicePreviewList?.totalTax
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="bconsultant text-right">
                {{
                  invoicePreviewList?.invoiceTotal
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="bconsultant text-right">
                {{
                  invoicePreviewList?.credits
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
              <td class="bconsultant text-right">
                {{
                  invoicePreviewList?.totalDue
                    | currency: "USD" : "symbol" : "1.2-2"
                }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No invoice preview found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="invoicePreviewSummaryDisplayModal"
  [displayModal]="invoicePreviewSummaryDisplayModal"
  (closeEvent)="closeModalForInvoicePreview()">
  <h1 class="panelHeading d-flex">
    Invoice Preview Summary
    <!-- <button
    type="button"
    class="betabtn ms-2"
  >
    Beta
  </button> -->
  </h1>
  <div class="panelBody">
    <jni-invoice-preview-summary
      [invoicePreviewNumberFromModal]="invoicePreviewNumber"
      [saleOrderId]="saleOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      [selectedRadioButton]="selectedRadioButton"
      (closeModalEvent)="
        closeModalForInvoicePreview()
      "></jni-invoice-preview-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="orderNotesDisplayModal"
  [displayModal]="orderNotesDisplayModal"
  (closeEvent)="closeModalForOrderNotes()">
  <h1 class="panelHeading">Billing Notes</h1>
  <div class="panelBody">
    <jni-invoice-preview-order-notes
      [orderNotesGridListing]="orderNotesGridListing"
      (scrollHiddenStatus)="
        addScollHiddenClass()
      "></jni-invoice-preview-order-notes>
  </div>
</jni-modal-stacker>
<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeClientModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [isModal]="true"
      [clientIdFromModal]="customerId"
      (closeEvent)="closeClientModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderIdModal"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-invoice-pdf-dialogue
  [displayModal]="invoicePdfDialogue"
  *ngIf="invoiceList?.length"
  (closeDialogEvent)="closeUrlDialog()"
  [invoiceList]="invoiceList"></jni-invoice-pdf-dialogue>
